export const VECTOR_ART_DATA_TYPE = 'Builder.VectorArt'
export const IMAGE_DATA_TYPE = 'Builder.Image'
export const VIDEO_DATA_TYPE = 'Builder.Video'
export const RICH_TEXT_DATA_TYPE = 'Builder.RichText'
export const MENU_ITEMS_DATA_TYPE = 'Builder.MenuItems'
export const MENU_ITEM_DATA_TYPE = 'Builder.MenuItem'
